module.exports = __webpack_public_path__ + "src/assets/games/14/101.jpg";